import React from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import LoginPage from './containers/LoginPage';
import AccountsPage from './containers/AccountsPage';
import ForgotPasswordPage from './containers/ForgotPasswordPage';

const App = () => {
  return (
    <React.StrictMode>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={() => <Redirect to="/login" />} />
          <Route exact path="/login" render={() => <LoginPage />} />
          <Route exact path="/accounts" render={() => <AccountsPage />} />
          <Route
            exact
            path="/forgot-password"
            render={() => <ForgotPasswordPage />}
          />
        </Switch>
      </BrowserRouter>
    </React.StrictMode>
  );
};

export default React.memo(App);
